import styled from 'styled-components'
import { themeColor } from '@elparking/components'

export default styled.div`
    width: 100%;
    background: ${themeColor('lightGray20')};
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 10;
    padding: 1em;
    form {
        max-width: 100%;
    }
`
